
import React, { useState } from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField } from "@mui/material";
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { useNavigate } from 'react-router-dom'
import Spacer from "../Spacer";
import { Alert } from "@mui/material";

interface ToggleProps {
  toggle: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
}

export default function SignInView(pops: ToggleProps) {

  const [open, setOpen] = pops.toggle
  const [emailField, setEmailField] = useState("")
  const [passwordField, setPasswordField] = useState("")
  const [error, setError] = useState(false);
  const [loginError, setLoginError] = useState<JSX.Element>();

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const errorMessage = (message: string) => {
    let messageView
    if (message) {
      messageView = (<><Spacer /><Alert severity="error">{message}</Alert></>)
    } else {
      messageView = (<></>)
    }
    setLoginError(messageView)
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailField(e.target.value);
    errorMessage("")
    setError(!validateEmail(e.target.value));
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [authing, setAuthing] = React.useState(false)
  const navigate = useNavigate()

  const signInWithEmail = async () => {
    if (!authing) {
      setAuthing(true)
      if (emailField && passwordField) {

        signInWithEmailAndPassword(auth, emailField, passwordField)
          .then((userCredential) => {
            navigate('/admin')
          })
          .catch((error) => {
            switch (error.code) {
              case 'auth/wrong-password':
                errorMessage("Invalid email or password")
                break;
              case 'auth/user-not-found':
                errorMessage("Invalid email or password")
                break;
            }
            setAuthing(false)
          });

      }
    }
  }

  return (
    <div>

      <Dialog open={open} onClose={handleClose} fullWidth={true}>
        <DialogTitle>Sign In</DialogTitle>
        <DialogContent>
          <TextField fullWidth value={emailField} label={"Email"} type={"email"} onChange={handleEmailChange}
            error={error}
            helperText={error ? 'Invalid email format' : ''}
          ></TextField>
          <Spacer />
          <TextField fullWidth label={"Password"} type={"password"} onChange={(e) => {
            setPasswordField(e.target.value)
            errorMessage("")
          }}></TextField>
          {loginError}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Cancel</Button>
          <Button onClick={signInWithEmail} color="secondary">Sign In</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
